<template>
	<div :class="mode === 'dark' ? 'dark' : 'light'">
		<b-button v-b-modal.modal-1 hidden>Launch demo modal</b-button>
		<b-modal id="modal-1" title="Actualiza tus datos">
			<p class="my-4">
				Para continuar participando y recibir información de temas de tu
				interés, te invitamos a actualizar tus datos en la plataforma Congreso Virtual.
			</p>
			<template #modal-footer>
				<a class="mt-3 btn btn-success btn-block" href="/user?update=1">Actualizar perfil</a>
			</template>
		</b-modal>
		<div class="container">
			<div class="row">
				<div v-if="loadProject" class="vld-parent">
					<img src="../assets/img/loader2.gif" style="height: 600px; width: 1200px"
						class="pl-0 ma-10 img-fluid col-12" />
				</div>
				<ProjectHeader id="project-header" :data-intro="$t('proyecto.ruta_guiada.pasos.paso_2')" data-step="2"
					v-if="!loadProject" :project="project"></ProjectHeader>
				<nav v-if="!loadProject" aria-label="breadcrumb" class="px-0">
					<ol class="breadcrumb" :style="mode === 'dark' ? 'background: rgb(12, 1, 80);' : ''">
						<li class="breadcrumb-item">
							<a href="/#" :style="mode === 'dark' ? 'color: #fff' : ''">{{ $t('proyecto.breadcumb.inicio')
							}}</a>
						</li>
						<li class="breadcrumb-item active" aria-current="page">
							<a href="/projects" :style="mode === 'dark' ? 'color: #fff' : ''">{{
									$t('proyecto.breadcumb.proyectos')
							}}</a>
						</li>
						<li class="breadcrumb-item active" aria-current="page" :style="mode === 'dark' ? 'color: #fff' : ''">
							{{ project.boletin }}
						</li>
					</ol>
				</nav>
				<div class="hk-sec-wrapper hk-gallery-wrap"
					:style="mode === 'dark' ? 'background: rgb(12, 1, 80);color: #fff' : ''">
					<div class="row px-10">
						<div class="col-sm-12 slider-wrapper mx-30">
							<ul class="nav nav-light nav-pills nav-fill" role="tablist"
								:data-intro="$t('proyecto.ruta_guiada.pasos.paso_1')" data-step="1">
								<li id="list-sections" class="nav-item" v-bind:class="(project.etapa !== 2) ? 'active' : ''" :data-intro="$t('proyecto.ruta_guiada.pasos.paso_3')"
									data-step="3">
									<a id="general-info-ideas-articles-tab" data-toggle="tab" href="#general-info-ideas-articles"
										role="tab" aria-controls="general-info-ideas-articles" aria-selected="true" class="nav-link"  v-bind:class="(project.etapa !== 2) ? 'active' : ''"
										:style="mode === 'dark' ? 'color: #fff' : ''">
										<!-- Resumen -->
										{{ $t('proyecto.tabs.resume') }}
									</a>
								</li>
								<li v-if="project.etapa !== 2" id="section-info" class="nav-item" :data-intro="$t('proyecto.ruta_guiada.pasos.paso_5')"
									data-step="5">
									<a id="detail-video-tab" data-toggle="tab" href="#detail-video" role="tab"
										aria-controls="detail-video" aria-selected="true" class="nav-link" @click="loadProjectI = true"
										:style="mode === 'dark' ? 'color: #fff' : ''">
										<!-- Vota y Opina -->
										{{ $t('proyecto.tabs.voteandopine') }}
									</a>
								</li>
								<li v-if="project.etapa !== 1" id="section-info" class="nav-item" v-bind:class="(project.etapa == 2) ? 'active' : ''">
									<a id="detail-articles-tab" data-toggle="tab" href="#detail-articles" role="tab"
										aria-controls="detail-articles" aria-selected="true" class="nav-link" @click="loadProjectI = true"  v-bind:class="(project.etapa == 2) ? 'active' : ''"
										:style="mode === 'dark' ? 'color: #fff' : ''">
										<!-- Articulos -->
										{{ $t('proyecto.tabs.articles') }}
									</a>
								</li>
								<li id="section-traces" class="nav-item" :data-intro="$t('proyecto.ruta_guiada.pasos.paso_6')"
									data-step="6">
									<a id="traces-tab" data-toggle="tab" href="#traces" role="tab" aria-controls="traces"
										aria-selected="true" class="nav-link" :style="mode === 'dark' ? 'color: #fff' : ''">
										<!-- Comentarios generales -->
										{{ $t('proyecto.tabs.gnralcomments') }}
									</a>
								</li>
								<li id="section-analysis" class="nav-item" :data-intro="$t('proyecto.ruta_guiada.pasos.paso_7')"
									data-step="7">
									<a id="analysis-tab" data-toggle="tab" href="#analysis" role="tab" aria-controls="analysis"
										aria-selected="true" class="nav-link" :style="mode === 'dark' ? 'color: #fff' : ''">
										<!-- Tramitación -->
										{{ $t('proyecto.tabs.processing') }}
									</a>
								</li>
								<li id="section-comentarios" class="nav-item" :data-intro="$t('proyecto.ruta_guiada.pasos.paso_9')"
									data-step="9">
									<a id="comentarios-tab" data-toggle="tab" href="#comments" role="tab" aria-controls="comments"
										aria-selected="true" class="nav-link" :style="mode === 'dark' ? 'color: #fff' : ''">
										<!-- Estadisticas -->
										{{ $t('proyecto.tabs.statistics') }}
									</a>
								</li>
								<li id="section-documentos" class="nav-item" :data-intro="$t('proyecto.ruta_guiada.pasos.paso_8')"
									data-step="8">
									<a id="documento-tab" data-toggle="tab" href="#anexos" role="tab" aria-controls="anexos"
										aria-selected="true" class="nav-link" :style="mode === 'dark' ? 'color: #fff' : ''">
										<!-- Anexos -->
										{{ $t('proyecto.tabs.annexes') }}
									</a>
								</li>
							</ul>
							<div class="tab-content py-25">
								<div id="general-info-ideas-articles" class="tab-pane fade show" role="tabpanel"
									aria-labelledby="general-info-ideas-articles-tab" v-bind:class="(project.etapa !== 2) ? 'active' : ''">
									<!--div class="row no-gutters py-5">
                                        <div class="col-12">
                                            <div class="">
                                                <div class="wrapper my-5">
                                                    <div class="arrow-steps clearfix row no-gutters">
                                                        <div class="col-12 mb-10">
                                                            <h3 class="text-center p-3" :style="mode==='dark'?'color: #fff':''">{{ $t('proyecto.contenido.resumen') }}</h3>
                                                            <div class="col-12 px-5 text-justify" v-html="project.resumen"></div>
                                                            <h5 class="pb-3 text-justify">
                                                                <small class :class="mode==='dark'?'':'text-muted '" :style="mode==='dark'?'color: #fff':''">{{ project.resumen }}</small>
                                                            </h5>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div -->
									<div class="row">
										<!--h3 class="text-center p-3" :style="mode==='dark'?'color: #fff':''">{{ $t('proyecto.contenido.tab.detalle') }}</h3-->
										<div class="col-12 px-5 text-justify mb-4 resumen" v-html="project.resumen"></div>
										<div v-if="ver_mas" class="col-12 px-5 text-justify" v-html="project.detalle">
										</div>
										<p @click="ver_mas = !ver_mas" href class="seemore-trigger">{{ ver_mas ? "Leer menos" : "...Leer mas" }}</p>
										<div v-if="project.video" class="col-12 px-5 mt-30 text-center">
											<h5>{{ $t('proyecto.contenido.video') }}</h5>
											<div class="col-12 d-flex justify-content-center">
												<div class="col-6 embed-responsive embed-responsive-16by9 mt-20" v-html-safe="project.video">
												</div>
											</div>
										</div>
									</div>
								</div>

								<div id="detail-video" class="tab-pane fade show" role="tabpanel" aria-labelledby="detail-video-tab">
									<div class="collapse show w-100" id="collapseIdeas">
										<ProjectIdeas v-if="!loadProject && loadProjectI" :id="this.id" :project="project"
											@updateStackedChartVotos="forceRerender"></ProjectIdeas>
									</div>
								</div>

								<div v-if="project.etapa !== 1" id="detail-articles" class="tab-pane fade show" role="tabpanel" aria-labelledby="detail-articles-tab"  v-bind:class="(project.etapa == 2) ? 'active' : ''">
                    				<ProjectArticles v-if="!loadProject"  :id="this.id" :project="project" @updateStackedChartVotos="forceRerender"></ProjectArticles>
								</div>

								<div id="traces" class="tab-pane fade show" role="tabpanel" aria-labelledby="traces-tab">
									<div class="col-12 hk-sec-wrapper hk-gallery-wrap"
										:style="mode === 'dark' ? 'background: rgb(12, 1, 80);color: #fff' : ''">
										<div class="row px-10">
											<div class="col-sm-12">
												<h3 class="mb-20 text-center" id="titulo_comentarios_">{{
														$t('componentes.comentarios.info_text.comentarios_de')
												}}</h3>
												<ProjectComments v-if="project.id" :project="project"></ProjectComments>
											</div>
										</div>
									</div>
								</div>

								<div id="analysis" class="tab-pane fade show" role="tabpanel" aria-labelledby="analysis-tab">
									<ProjectTraces v-if="project.id" :project="project"></ProjectTraces>
								</div>
								<div v-if="project.files !== 'undefined'" id="comments" class="tab-pane fade show" role="tabpanel"
									aria-labelledby="comments-tab">

									<div class="card" :style="mode === 'dark' ? 'background: rgb(12, 1, 80);' : ''"
										:class="mode === 'dark' ? '' : 'bg-light-15'">
										<div class="row mx-0">
											<div class="col-md-12 mt-15 mb-10">
												<h3 class="hk-sec-title text-center" :style="mode === 'dark' ? 'color: #fff' : ''">
													{{ $t('proyecto.contenido.analisis_votos') }}
												</h3>
											</div>
											<div class="col-md-12 mt-15 mb-10">
												<p class="hk-sec-title" :style="mode === 'dark' ? 'color: #fff' : ''">
													{{ $t('proyecto.contenido.recomendacion') }}
												</p>
											</div>
										</div>
										<div class="row">
											<div class="col-md-12 mt-15 mb-15">
												<div class="col-12">
													<ProjectBarCharts v-if="project.id" :project="project" :key="keyStackedChartComponent">
													</ProjectBarCharts>
												</div>
											</div>
										</div>
									</div>
									<div class="card" :style="mode === 'dark' ? 'background: rgb(12, 1, 80);' : ''"
										:class="mode === 'dark' ? '' : 'bg-light-15'">
										<div class="row mx-0 text-center">
											<div class="col-6 py-15">
												<h5 :style="mode === 'dark' ? 'color: #fff' : ''">{{
														$t('proyecto.contenido.cantidad_comentarios')
												}}</h5>
												<h2 class="my-15" :style="mode === 'dark' ? 'color: #fff' : ''">{{
														project.total_comments
												}}</h2>
											</div>
											<div class="col-6 py-15">
												<h5 :style="mode === 'dark' ? 'color: #fff' : ''">{{
														$t('proyecto.contenido.cantidad_participantes')
												}}</h5>
												<h2 class="my-15" :style="mode === 'dark' ? 'color: #fff' : ''">{{
														project.total_participants
												}}</h2>
											</div>
										</div>
									</div>
									<div class="card" :style="mode === 'dark' ? 'background: rgb(12, 1, 80);' : ''"
										:class="mode === 'dark' ? '' : 'bg-light-15'">
										<ProjectPieCharts v-if="project.id" :project="project"></ProjectPieCharts>
									</div>
									<div class="card" :style="mode === 'dark' ? 'background: rgb(12, 1, 80);' : ''"
										:class="mode === 'dark' ? '' : 'bg-light-15'">
										<div class="row mx-0 justify-content-center">
											<h3 class="hk-sec-title mt-20" :style="mode === 'dark' ? 'color: #fff' : ''">
												{{ $t('proyecto.contenido.nube') }}
											</h3>
										</div>
										<div class="pa-20">
											<WordCloud :project_id="this.id"></WordCloud>
										</div>
									</div>
									<br>
									<ProjectParticipantsRanking :project_id="this.id"></ProjectParticipantsRanking>
								</div>

								<div v-if="project.files !== 'undefined'" id="anexos" class="tab-pane fade show" role="tabpanel"
									aria-labelledby="anexos-tab">
									<div class="">
										<div class="wrapper my-5">
											<div class="arrow-steps clearfix row no-gutters">
												<div v-if="seguimiento.length > 0" class="col-12 row">
													<div class="col-12 col-md-6  mb-10 p-3">
														<h5 :style="mode === 'dark' ? 'color: #fff' : ''">{{
																$t('proyecto.contenido.autoria')
														}}</h5>
														<h5>
															<small class :class="mode === 'dark' ? '' : 'text-muted '"
																:style="mode === 'dark' ? 'color: #fff' : ''">{{
																		seguimiento[0].AUTORES
																}}</small>
														</h5>
													</div>
													<div class="col-12 col-md-6  p-3">
														<h5 :style="mode === 'dark' ? 'color: #fff' : ''">{{
																$t('proyecto.contenido.iniciativa')
														}}</h5>
														<h5>
															<small class :class="mode === 'dark' ? '' : 'text-muted '"
																:style="mode === 'dark' ? 'color: #fff' : ''">{{
																		seguimiento[0].INICIATIVA
																}}</small>
														</h5>
													</div>
													<div class="col-12 col-md-6  mb-10 p-3">
														<h5 :style="mode === 'dark' ? 'color: #fff' : ''">{{
																$t('proyecto.contenido.origen')
														}}</h5>
														<h5>
															<small class :class="mode === 'dark' ? '' : 'text-muted '"
																:style="mode === 'dark' ? 'color: #fff' : ''">{{
																		seguimiento[0].ORIGEN
																}}</small>
														</h5>
													</div>
													<div class="col-12 col-md-6  mb-10 p-3">
														<h5 :style="mode === 'dark' ? 'color: #fff' : ''">{{
																$t('proyecto.contenido.tramitacion')
														}}</h5>
														<h5>
															<small class :class="mode === 'dark' ? '' : 'text-muted '"
																:style="mode === 'dark' ? 'color: #fff' : ''">{{
																		seguimiento[0].TRAMDESCRIPCION
																}}</small>
														</h5>
													</div>
													
												</div>
											</div>
											<!--REFUNDIDOS-->
											<div class="my-5">
												<TablaList v-if="project.boletin_refund" :projects="project.boletin_refund"/>
											</div>
										</div>
									</div>
									<div class="row">
										<div class="col-12">
											<ProjectFiles :project_id="this.id" :imagen_id="project.imagen_id">
											</ProjectFiles>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- <div class="col-12 hk-sec-wrapper hk-gallery-wrap" :style="mode==='dark'?'background: rgb(12, 1, 80);color: #fff':''">
                    <div class="row px-10">
                        <div class="col-sm-11 mx-30" id="titulo_documentos_">
                            <ProjectFiles :project_id="this.id"></ProjectFiles>
                        </div>
                    </div>
                </div> -->
				<!-- <div class="col-12 hk-sec-wrapper hk-gallery-wrap" :style="mode==='dark'?'background: rgb(12, 1, 80);color: #fff':''">
                    <div class="row px-10">
                        <div class="col-sm-11 mx-30">
                            <ProjectParticipantsRanking :project_id="this.id"></ProjectParticipantsRanking>
                        </div>
                    </div>
                </div> -->

			</div>
		</div>
		<div class="modal fade" id="modalMessage" tabindex="-1" role="dialog" aria-labelledby="modalCenterTitle"
			aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title">Votación Realizada</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<p>Además de votar a favor, en contra o abstención sobre un proyecto, puede hacerlo también con
							las <strong>Ideas Fundamentales</strong> y <strong>Artículos</strong> del proyecto de ley
							actual.</p>
					</div>
					<div class="modal-footer">
						<a type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</a>
						<a href="#section-votes" type="button" class="btn btn-primary"
							@click="focusVotesSection($event)">Aceptar</a>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import TablaList from '../components/admin/projects/Tabla'
import ProjectHeader from '../components/projects/ProjectHeader';
import ProjectIdeas from '../components/projects/ProjectIdeas';
import ProjectArticles from '../components/projects/ProjectArticles';
import ProjectTraces from '../components/projects/ProjectTraces';
import ProjectBarCharts from '../components/projects/ProjectBarCharts';
import ProjectPieCharts from '../components/projects/ProjectPieCharts';
import ProjectFiles from '../components/projects/ProjectFiles';
import ProjectParticipantsRanking from '../components/projects/ProjectParticipantsRanking';
import ProjectComments from './Comments';
import WordCloud from '../components/projects/WordCloud';
import axios from '../backend/axios';
import axioma from 'axios';
import 'intro.js/minified/introjs.min.css';
import { bus } from '../main';
import VueScrollTo from "vue-scrollto";

export default {
	name: 'Project',
	components: {
		ProjectHeader,
		ProjectIdeas,
		ProjectArticles,
		ProjectTraces,
		ProjectBarCharts,
		ProjectPieCharts,
		ProjectFiles,
		ProjectParticipantsRanking,
		ProjectComments,
		WordCloud,
		VueScrollTo,
		TablaList
	},
	props: {
		id: Number,
		mode: String
	},
	data() {
		return {
			project: Object,
			ver_mas: false,
			seguimiento: [],
			keyStackedChartComponent: 0,
			loadProject: true,
			loadProjectI: false,
			fullPage: false,
			color: '#ffffff'
		};
	},
	mounted() {
		if ((this.$store.getters.modo_oscuro === 'dark') || (window.location.href.includes('dark'))) {
			this.mode = 'dark';
		} else {
			this.mode = 'light';
		}
		this.getProject(this.id);

		let lablesButtons = {
			nextLabel: this.$t('proyecto.ruta_guiada.opciones.boton_siguiente'),
			prevLabel: this.$t('proyecto.ruta_guiada.opciones.boton_anterior'),
			skipLabel: this.$t('proyecto.ruta_guiada.opciones.boton_salir'),
			doneLabel: this.$t('proyecto.ruta_guiada.opciones.boton_finalizar')
		};
		bus.$on('tour', function () {
			const introJS = require('intro.js');
			introJS
				.introJs()
				.setOption('nextLabel', lablesButtons.nextLabel)
				.setOption('prevLabel', lablesButtons.prevLabel)
				.setOption('skipLabel', lablesButtons.skipLabel)
				.setOption('doneLabel', lablesButtons.doneLabel)
				.setOption('scrollToElement', true)
				.start()
				.onchange(function (targetElement) {
					if ($(targetElement).attr("data-step") == 4) {
						$('#btn-ideas').click();
					}
				})
		});
		this.getUser();
	},
	created() {
		Chart.helpers.merge(Chart.defaults.global.plugins.datalabels, {
			color: '#ffffff',
			formatter: function (value, context) {
				let sum = 0;
				let dataArr = context.chart.data.datasets[0].data;
				dataArr.map(data => {
					sum += data;
				});
				let percentage = (value * 100 / sum).toFixed(1);
				return percentage + '%';
			}
		});
	},
	methods: {
		focusVotesSection(e) {
			$('#modalMessage').modal('hide');

			$('html, body').animate({
				scrollTop: $('#section-votes').offset().top + 'px'
			}, 1500);
			$('#btn-ideas').click();
		},
		getProject(id) {
			axios
				.get('/projects/' + id)
				.then(res => {
					this.project = res.data;
				})
				.finally(() => {
					axios
						.get('settings', {
							params: {
								key: 'external_api'
							}
						})
						.then(res => {
							if (res.data.length > 0) {
								let generalInfoProjectUrl = JSON.parse(res.data[0].value).general_info_project;
								axioma
									.create()
									.get(generalInfoProjectUrl + this.project.boletin)
									.then(res => {
										this.seguimiento = res.data;
									})
									.finally(() => {
										this.loadProject = false;
									});
							} else {
								this.loadProject = false;
							}
						})
						.catch(() => {
							this.loadProject = false;
						});
					if (this.$route.hash == '#titulo_comentarios_')
						location.href = "#titulo_comentarios_";
				});
		},
		forceRerender() {
			this.keyStackedChartComponent += 1;
		},
		
		getUser() {
			if (this.$store.getters.isLoggedIn) {
				axios
					.get('/auth/user')
					.then(res => {
						if (!res.data.actividad) {
							this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')
						}
					})
					.finally(() => {
					});
			}
		},
	},
	computed: {
		isAvailableGamification() {
			return this.$store.getters.activeGamification;
		}
	}
};
</script>

<style scoped>

.slider-wrapper{
	flex: auto;
}
.arrow-steps .step {
	font-size: 14px;
	cursor: default;
	padding: 10px 10px 10px 30px;
	float: left;
	position: relative;
	background-color: #d9e3f7;
	-webkit-user-select: none;
	-moz-user-select: none;
	-ms-user-select: none;
	user-select: none;
	transition: background-color 0.2s ease;
}

.arrow-steps .step:after,
.arrow-steps .step:before {
	content: " ";
	position: absolute;
	top: 0;
	right: -16px;
	width: 0;
	height: 0;
	border-top: 25px solid transparent;
	border-bottom: 25px solid transparent;
	border-left: 17px solid #9e9e9e !important;
	z-index: 2;
	transition: border-color 0.2s ease;
}

.arrow-steps .bg-primary.step:before {
	border-left: 17px solid green !important;
}

.arrow-steps .step:before {
	right: auto;
	left: 0;
	border-left: 17px solid #fff;
	z-index: 0;
}

.arrow-steps .step:first-child:before {
	border: none;
}

.arrow-steps .step:first-child {
	border-top-left-radius: 4px;
	border-bottom-left-radius: 4px;
}

.arrow-steps .step span {
	position: relative;
}

.arrow-steps .step span:before {
	opacity: 0;
	content: "✔";
	position: absolute;
	top: -2px;
	left: -20px;
}

.arrow-steps .step.done span:before {
	opacity: 1;
	-webkit-transition: opacity 0.3s ease 0.5s;
	-moz-transition: opacity 0.3s ease 0.5s;
	-ms-transition: opacity 0.3s ease 0.5s;
	transition: opacity 0.3s ease 0.5s;
}

.arrow-steps .step.current {
	color: #fff;
	background-color: green !important;
}

.arrow-steps .step.current:after {
	border-left: 17px solid green !important;
}
</style>